module.exports = "/assets/4ac9dc2b2d312ad22305fc865aba4ad0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/8A.png
// module id = 1128
// module chunks = 0